<span class="badge rounded-pill {{badgeClass}} {{badgeColor}}">
    {{label}}
</span>
